
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gift-card",
      function () {
        return require("private-next-pages/gift-card/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gift-card"])
      });
    }
  